<template>
  <div
    :grc_dateformat="settings.dateformat"
    :grc_sep="settings.datesep"
    :grc_firtsdayofweek="settings.firstdayofweek"
    :grc_daynames="settings.daynames"
    :grc_monthnames="settings.monthnames"

    :value="component_value"
  >
    <table class="grc-cal-header-table" cellspacing="0" cellpadding="0">
        <tr>
            <td @click="AddMonth(-1)" class="grc-cal-header-table-icon" style="text-align: center;"><i class="fas fa-caret-left"></i></td>
            <td class="grc-cal-header-table-ym">{{header_text}}</td>
            <td @click="AddMonth(1)" class="grc-cal-header-table-icon" style="text-align: center;"><i class="fas fa-caret-right"></i></td>
        </tr>
    </table>
    <table class="grc-cal-table">
      <thead>
        <th v-for="th in th_daynames" class="grc-cal-table-th">
          {{th.text }}
        </th>
      </thead>
      <tbody>
        <tr v-for="tr in tabledata">
            <td v-for="td in tr" 
            :class="['grc-cal-table-td', td.samemonth ? '' : 'grc-cal-table-td-notsamemonth', td.selected ? 'grc-cal-table-td-selected' : '',
            td.IsEnabled ? '':'grc-cal-table-td-disabled']" 
            @click="DateClick(td.val)">
              {{td.text}}
            </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'GrcCalendar',
  components:
  {

  },
  props: {
    value: String,
    grc_dateformat: String,
    grc_sep: String,
    grc_firstdayofweek: String,
    grc_daynames: String,
    grc_monthnames: String
  },
  data () {
    return {
        component_value: "",
        prev_component_value:"",
        selected_date: new Date(),
        work_date: new Date(),
        header_text: "",

        settings: { dateformat: this.grc_dateformat, datesep: this.grc_sep, firstdayofweek: this.grc_firstdayofweek, 
        daynames: this.grc_daynames, monthnames: this.grc_monthnames },

        th_daynames:{},
        tabledata: {},

        MinDate: new Date(),
        MaxDate: new Date(),

    }
  },
  watch : {
    value (pNewValue) {
      if (pNewValue !== this.prev_component_value) {
          this.prev_component_value = pNewValue;
          this.component_value = pNewValue;
      }

      this.SetWorkDate(pNewValue);      
    },

    work_date(pNewDate)
    {
        this.RefreshHeaderText();
    }
  },

  created: function()
  {
    var today = new Date();
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate());    
    this.work_date = new Date(today.getFullYear(), today.getMonth(), 1);

    this.MinDate = new Date(today.getFullYear()-2000, 1, 1);    
    this.MaxDate = new Date(today.getFullYear()+1000, 12, 131);    

    this.ValidateFormat();
    this.ValidateSeparator();
    this.ValidateFirstDayOfWeek();
    this.ValidateDayNames();
    this.ValidateMonthNames();
  },
  computed: {
    
  },

  mounted: function()
  {

  },

  methods: {

    SetMinMaxDate(pMinDate, pMaxDate)
    {
      var onlyNum = pMinDate.replace(/[^0-9]+/g, '');
      onlyNum = onlyNum.padEnd(8, '0');

      var y = 0;
      var m = 0;
      var d = 0;

      if (this.settings.dateformat == "ymd")
      {
          y = parseInt(onlyNum.substr(0,4));
          m = parseInt(onlyNum.substr(4,2));
          d = parseInt(onlyNum.substr(6,2));
      }

      if (this.settings.dateformat == "mdy")
      {
          y = parseInt(onlyNum.substr(4,4));
          m = parseInt(onlyNum.substr(0,2));
          d = parseInt(onlyNum.substr(2,2));
      }

      if (this.settings.dateformat == "dmy")
      {
          y = parseInt(onlyNum.substr(4,4));
          m = parseInt(onlyNum.substr(2,2));
          d = parseInt(onlyNum.substr(0,2));
      }

      m = m - 1;
      this.MinDate = new Date(y,m,d);



      onlyNum = pMaxDate.replace(/[^0-9]+/g, '');
      onlyNum = onlyNum.padEnd(8, '0');

      y = 0;
      m = 0;
      d = 0;

      if (this.settings.dateformat == "ymd")
      {
          y = parseInt(onlyNum.substr(0,4));
          m = parseInt(onlyNum.substr(4,2));
          d = parseInt(onlyNum.substr(6,2));
      }

      if (this.settings.dateformat == "mdy")
      {
          y = parseInt(onlyNum.substr(4,4));
          m = parseInt(onlyNum.substr(0,2));
          d = parseInt(onlyNum.substr(2,2));
      }

      if (this.settings.dateformat == "dmy")
      {
          y = parseInt(onlyNum.substr(4,4));
          m = parseInt(onlyNum.substr(2,2));
          d = parseInt(onlyNum.substr(0,2));
      }

      m = m - 1;
      this.MaxDate = new Date(y,m,d);

      this.RefreshHeaderText();
    },

      SetWorkDate(pText)
      {
        var today = new Date();
        var CheckOK = true;

        var onlyNum = pText.replace(/[^0-9]+/g, '');
        onlyNum = onlyNum.padEnd(8, '0');

        var y = 0;
        var m = 0;
        var d = 0;

        if (this.settings.dateformat == "ymd")
        {
            y = parseInt(onlyNum.substr(0,4));
            m = parseInt(onlyNum.substr(4,2));
            d = parseInt(onlyNum.substr(6,2));
        }

        if (this.settings.dateformat == "mdy")
        {
            y = parseInt(onlyNum.substr(4,4));
            m = parseInt(onlyNum.substr(0,2));
            d = parseInt(onlyNum.substr(2,2));
        }

        if (this.settings.dateformat == "dmy")
        {
            y = parseInt(onlyNum.substr(4,4));
            m = parseInt(onlyNum.substr(2,2));
            d = parseInt(onlyNum.substr(0,2));
        }

        if (y < 1000)
        {
            y = today.getFullYear();
            CheckOK = false;
        }

        if (m<1 || m>12)
        {
          m = today.getMonth()+1;
          CheckOK = false;
        }

        m = m-1;


        var maxday = new Date(y, m, 0).getDate();

        if (d<1 || d>maxday)
        {
          d = today.getDate();
          CheckOK = false;
        }

        
        
        if (CheckOK)
        {
          this.selected_date = new Date(y,m,d);
        }
        else
        {
          this.selected_date = new Date();
        }

        this.work_date = new Date(y,m,1);

      },

    CheckText: function(pText)
    {
      var CheckOK = true;
      
      var repchars = "[^0-9"+this.settings.datesep+"]+";
      var regex = new RegExp(repchars, "g");
      var cv = pText.replace(regex, "");

      if (cv != pText) { CheckOK = false; }
      
      var onlyNum = pText.replace(/[^0-9]+/g, '');

      if (cv.length - onlyNum.length >2) { CheckOK = false; } // kettonel tobb separator
      if (onlyNum.length > 8) { CheckOK = false; } // 8 szamjegynel tobb

      return CheckOK;
    },


      DateClick(pDate)
      {
        var IsEnabled = true;
        if (this.CompareDates(pDate, this.MinDate) < 0) { IsEnabled = false; }
        if (this.CompareDates(pDate, this.MaxDate) > 0) { IsEnabled = false; }

        if (IsEnabled == false) { return; }

        var y = (""+pDate.getFullYear()).padStart(4,'0');
        var m = (""+(pDate.getMonth()+1)).padStart(2,'0');
        var d = (""+pDate.getDate()).padStart(2,'0');

        var s = "";

        if (this.settings.dateformat == "ymd")
        {
          s = "" + y + this.settings.datesep+m+this.settings.datesep+d;
        }

        if (this.settings.dateformat == "mdy")
        {
          s = "" + m + this.settings.datesep+d+this.settings.datesep+y;
        }

        if (this.settings.dateformat == "dmy")
        {
          s = "" + d + this.settings.datesep+m+this.settings.datesep+y;
        }

        this.prev_component_value = s;
        this.component_value = s;

        this.$emit('input', this.component_value);

        this.$emit('closedropdown');

      },

      CompareDates(pDate1, pDate2)
      {
        var y = (""+pDate1.getFullYear()).padStart(4,'0');
        var m = (""+(pDate1.getMonth()+1)).padStart(2,'0');
        var d = (""+pDate1.getDate()).padStart(2,'0');

        var D1 = y+m+d;

        y = (""+pDate2.getFullYear()).padStart(4,'0');
        m = (""+(pDate2.getMonth()+1)).padStart(2,'0');
        d = (""+pDate2.getDate()).padStart(2,'0');

        var D2 = y+m+d;

        return D1.localeCompare(D2);
        // 0: ugyanaz, -1: D1 < D2, 1: D1 > D2
      },

      RefreshHeaderText()
      {
        var y = this.work_date.getFullYear();
        var m = this.work_date.getMonth();

        var msa = this.settings.monthnames.split(',');

        this.header_text = ""+y+". "+msa[m];

        var n = this.work_date.getDay(); //0: vasarnap

        if (this.settings.firstdayofweek == "mon")
        {
          n = n - 1;
        }

        if (n < 0) { n = n + 7; }

        var d = new Date(this.work_date.getFullYear(), this.work_date.getMonth(), this.work_date.getDate()-n);

        var maxdate = new Date(d.getFullYear(), d.getMonth(),d.getDate() + 42);

        var items = new Array();
        var arr = new Array();

        var i = 0;

        while(d < maxdate)
        {
            i++;
            var o = new Object();
            o.text = ""+d.getDate();
            o.val = d;
            o.samemonth = (d.getMonth() == this.work_date.getMonth());
            o.selected = (d.getFullYear() == this.selected_date.getFullYear() && d.getMonth() == this.selected_date.getMonth() && d.getDate() == this.selected_date.getDate());

            o.IsEnabled = true;
            if (this.CompareDates(d, this.MinDate) < 0) { o.IsEnabled = false; }
            if (this.CompareDates(d, this.MaxDate) > 0) { o.IsEnabled = false; }
            

            arr.push(o);

            if (i==7)
            {
              items.push(Array.from(Object.create(arr)));
              arr = new Array();
              i=0;
            }
            
            d = new Date(d.getFullYear(), d.getMonth(), d.getDate()+1);
        }

        this.tabledata = items;
      },

      AddMonth(pValue)
      {
        var y = this.work_date.getFullYear();
        var m = this.work_date.getMonth() + pValue;
        this.work_date = new Date(y,m,1);
      },

    ValidateDayNames()
    {
      if (typeof this.settings.daynames == "undefined")
      {
        this.settings.daynames = grccomp_GetDefaults_Date().daynames;
      }

      var sa = this.settings.daynames.split(",");
      if (sa.length<7)
      {
        this.settings.daynames = grccomp_GetDefaults_Date().daynames;
        sa = this.settings.daynames.split(",");
      }

      var tharr = new Array();
      if (this.settings.firstdayofweek == "mon")
      {
        for(var i=1; i<sa.length;i++)
        {
          var o = new Object();
          o.text = ""+sa[i];
          tharr.push(o);
        }
        var o = new Object();
        o.text = ""+sa[0];
        tharr.push(o);
      }
      else
      {
        for(var i=0; i<sa.length;i++)
        {
          var o = new Object();
          o.text = ""+sa[i];
          tharr.push(o);
        }
      }

      this.th_daynames = Array.from(Object.create(tharr));

    },

    ValidateMonthNames()
    {
      if (typeof this.settings.monthnames == "undefined")
      {
        this.settings.monthnames = grccomp_GetDefaults_Date().monthnames;
      }

      var sa = this.settings.monthnames.split(",");
      if (sa.length<12)
      {
        this.settings.monthnames = grccomp_GetDefaults_Date().monthnames;
      }
    },

    ValidateFirstDayOfWeek()
    {
      var formatlist = ["mon", "sun"];
      if (formatlist.includes(this.settings.firstdayofweek) == false)
      {
        this.settings.firstdayofweek = grccomp_GetDefaults_Date().firstdayofweek;
      }
    },

    ValidateFormat()
    {
      var formatlist = ["ymd", "mdy", "dmy"];
      if (formatlist.includes(this.settings.dateformat) == false)
      {
        this.settings.dateformat = grccomp_GetDefaults_Date().dateformat;
      }
    },

    ValidateSeparator()
    {
      var seplist = [".", "-", "/"];
      if (seplist.includes(this.settings.datesep) == false)
      {
        this.settings.datesep = grccomp_GetDefaults_Date().sep;
      }
    },

    DisplayValue(pNewValule)
    {
        var s = this.FormatText(pNewValule);

        this.prev_display_text = s;
        this.display_text = s;
    },

  } // methods


  
}
</script>

<style scoped>
.grc-cal-table-td-disabled
{
  background-color: transparent;
  opacity: 1;
  color: pink;
  cursor:normal !important;
}

.grc-cal-table-td-disabled:hover
{
  background-color: transparent;
  opacity: 1;
  color: pink;
  cursor:normal !important;
}

</style>